import { OrganizationsPage } from "../../features/organizations";

export function AdminOrganizationsPage() {
  return <OrganizationsPage />;
}
